import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { POSITIONS } from "./careersConfig";
import { RequiredMark, sectionBorder } from "./careersUi";

export function RoleSection({ form, set, isMissing }) {
  const hasMissing = isMissing("position") || isMissing("availability");
  return (
    <div className={`bg-white p-6 rounded-2xl border ${sectionBorder(hasMissing)} space-y-4`}>
      <h2 className="font-display font-semibold text-lg">Role & Compensation</h2>
      <div className="grid sm:grid-cols-3 gap-4">
        <div className="sm:col-span-2">
          <Label>Position applying for<RequiredMark/></Label>
          <Select value={form.position} onValueChange={(v) => set("position", v)}>
            <SelectTrigger data-testid="careers-position" className={isMissing("position") ? "border-amber-400" : ""}><SelectValue/></SelectTrigger>
            <SelectContent>{POSITIONS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Desired hourly $</Label>
          <Input type="number" step="0.5" value={form.desired_hourly_salary} onChange={(e) => set("desired_hourly_salary", e.target.value)} placeholder="0.00" data-testid="careers-salary"/>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Full-time or part-time?</Label>
          <Select value={form.work_type} onValueChange={(v) => set("work_type", v)}>
            <SelectTrigger data-testid="careers-work-type"><SelectValue/></SelectTrigger>
            <SelectContent>
              <SelectItem value="full_time">Full-time</SelectItem>
              <SelectItem value="part_time">Part-time</SelectItem>
              <SelectItem value="either">Either</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div><Label>When can you start?</Label><Input value={form.start_date} onChange={(e) => set("start_date", e.target.value)} placeholder="e.g. Immediately, 2 weeks notice" data-testid="careers-start-date"/></div>
      </div>
      <div>
        <Label>Availability (days / hours)<RequiredMark/></Label>
        <Input value={form.availability} onChange={(e) => set("availability", e.target.value)} placeholder="Weekdays 9AM – 6PM, Weekends Open" data-testid="careers-availability" className={isMissing("availability") ? "border-amber-400" : ""}/>
      </div>
    </div>
  );
}
